import BaseForm from '../base';
import { LatLongColumnsComponent } from '../components';
export class EmergencyGpsForm extends BaseForm {
    constructor(...args) {
        super(...args);
        this.components = [
            new LatLongColumnsComponent(),
            {
                label: 'Serial Number',
                key: 'serialNumber',
                type: 'textfield',
            },
            {
                label: 'Color',
                key: 'color',
                type: 'textfield',
            },
            {
                label: 'Limit',
                key: 'limit',
                type: 'number',
            },
        ];
    }
}
